import { isLocalhost } from "../../utils/isLocalhost";

/**
 * Clips is a limited rollout. Available everywhere on localhost (dev),
 * and in production only for the allowlisted companies below.
 */
export const CLIPS_ALLOWED_COMPANY_IDS = ["6897d186f21cc2f34a9698b1"];

export function canAccessClipsCompany(companyId?: string | null): boolean {
  if (isLocalhost()) return true;
  return companyId != null && CLIPS_ALLOWED_COMPANY_IDS.includes(companyId);
}
